// import Filters from "../filters";
// import FiltersModal from "../filters/filters-modal";
import ProductsWrapper from "./products-wrapper";
import dynamic from "next/dynamic";
import { useContext } from "react";
import { AppContext } from "@/contexts/appContexts";
import { getCategoryData } from "@/utils/category";
import Description from "@/components/Category/Description";

const Filters = dynamic(() => import("../filters"), {
  ssr: false,
});
const FiltersModal = dynamic(() => import("../filters/filters-modal"), {
  ssr: false,
});
import { useExcludeFilters } from "@/hooks/useExcludeFilters";

const CategoryWrapper = ({ data, categoryId, device }) => {
  const { products, filters, totalProduct, pages } = data;
  const filteredFacets = useExcludeFilters({ filters, categoryId });

  const { categoryData } = useContext(AppContext);
  const cat = getCategoryData(categoryData?.children_data, "id", categoryId);

  return (
    <div className="w-[80%] max-[570px]:w-[98%] mx-auto mt-5 relative grid grid-cols-2 md:grid-cols-4 gap-4 mb-4">
      {/* filters */}
      <div className="max-[768px]:hidden">
        <Filters filters={filteredFacets} />
      </div>
      <div className="hidden max-[768px]:block col-span-2">
        <FiltersModal filters={filteredFacets} />
      </div>
      <div className="flex flex-col col-span-2 gap-4 md:col-span-3">
        <ProductsWrapper
          serSideProducts={products}
          serverSideTotalProduct={totalProduct}
          categoryId={categoryId}
          filters={filteredFacets}
          serverSidePages={pages}
          device={device}
        />
      </div>
      {cat?.category_text_description && (
        <div className="col-span-2 md:col-span-4">
          <Description desc={cat?.category_text_description} />
        </div>
      )}
    </div>
  );
};

export default CategoryWrapper;
